/**
 * Emoji utility functions for working with Unicode emoji representations.
 */

/**
 * Converts an emoji string to its unified format (hyphen-separated hex code points).
 *
 * This handles all emoji types including:
 * - Single code point emojis (e.g., 👍 → "1f44d")
 * - Skin tone modifiers (e.g., 👍🏻 → "1f44d-1f3fb")
 * - ZWJ sequences (e.g., 👨‍👩‍👧 → "1f468-200d-1f469-200d-1f467")
 * - Regional indicator sequences/flags (e.g., 🇺🇸 → "1f1fa-1f1f8")
 *
 * @param {string} emoji - The emoji string to convert
 * @returns {string} The unified format (lowercase hex code points joined by hyphens)
 */
export const emojiToUnified = (emoji) => {
  if (!emoji) return '';
  return [...emoji].map(char => char.codePointAt(0).toString(16)).join('-');
};
